import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import cognitesdk from '@cognite/cognitesdk';
import { Link } from 'react-router-dom';
import { List, Card, Breadcrumb, Icon, Input } from 'antd';
import escapeRegexp from 'escape-string-regexp';
import styled from 'styled-components';
import RightSidebar from 'components/RightSidebar';
import AssetMeta from 'components/AssetMeta';

const Meta = Card.Meta;
const Search = Input.Search;

const MetaWrapper = styled(Meta)`
  height: 60px;
`;

const MainWrapper = styled.div`
  .ant-list-pagination {
    text-align: left;
  }
`;

const BreadcrumbWrapper = styled.div`
  margin-bottom: 15px;
`;

const CardWrapper = styled(Card)``;

class AssetExplorerContainer extends React.Component {
  state = {
    path: [],
    children: [],
    selectedNode: null,
    loading: false,
    page: 1,
    search: '',
  };

  componentDidMount() {
    this.getAssets();
  }

  componentDidUpdate(prevProps, prevState) {
    const { id: nextId } = this.props.match.params;
    const { id: prevId } = prevProps.match.params;
    const { search: prevSearch } = prevState;
    const { search: nextSearch } = this.state;
    if (nextId !== prevId) {
      this.getAssets();
    }
    if (prevSearch.length > 0 && nextSearch.length === 0) {
      this.setState({
        page: 1,
      });
    }
  }

  onSelect = node => {
    this.props.dispatch(push(`/assets/${node.id}`));
  };

  getAssets = async () => {
    this.setState({
      loading: true,
      path: [],
      nodes: [],
      selectedNode: null,
      search: '',
      page: 1,
    });
    const { id } = this.props.match.params;
    const { project } = this.props;
    if (!id) {
      const res = await cognitesdk.get(
        `api/0.4/projects/${project}/assets?depth=0`
      );
      return this.setState({
        children: res.items.sort((a, b) => a.name.localeCompare(b.name)),
        loading: false,
      });
    }
    const res = await cognitesdk.get(
      `api/0.4/projects/${project}/assets/${id}?depth=1&limit=10000`
    );
    if (res.items.length > 0) {
      const [current, ...children] = res.items;
      const path = await this.buildPath(current);
      this.setState({
        path,
        children: children.sort((a, b) => a.name.localeCompare(b.name)),
        loading: false,
      });
      if (children.length === 0) {
        this.showMeta(current);
      }
      return;
    }
    console.log('Not a valid ID');
    return 1;
  };

  buildPath = async parent => {
    let path = [parent];
    let current = parent;
    const { project } = this.props;
    while (current.parentId) {
      /* eslint-disable no-await-in-loop */
      const res = await cognitesdk.get(
        `api/0.4/projects/${project}/assets/${current.parentId}?depth=0`
      );
      if (res.items.length > 0) {
        current = res.items[0];
        path = [current, ...path];
      } else {
        break;
      }
    }
    return path;
  };

  showMeta = async node => {
    if (!node.timeseries) {
      const res = await cognitesdk.getTimeseries({ assetId: node.id });
      node.timeseries = res.items;
      this.setState({
        selectedNode: node,
      });
    } else {
      this.setState({
        selectedNode: node,
      });
    }
  };

  requestMountedOn = async name => {
    const { project } = this.props;
    const res = await cognitesdk.get(
      `api/0.4/projects/${project}/assets?name=${name}`
    );
    if (res.items.length > 0) {
      this.props.dispatch(push(`/assets/${res.items[0].id}`));
    }
  };

  render() {
    const { path, children, selectedNode, loading, page, search } = this.state;
    const searchRegex = search
      .split(' ')
      .map(s => new RegExp(escapeRegexp(s), 'gi'));
    const slicer = input => input.slice((page - 1) * 24, page * 24);
    let dataSource = children;
    if (search.length > 0) {
      dataSource = children.filter(node => {
        const token = `${node.name}${node.description}`;
        return searchRegex.reduce((p, c) => p && token.match(c), true);
      });
    }
    return (
      <MainWrapper>
        <BreadcrumbWrapper>
          <Breadcrumb>
            {path.map((node, i) => (
              <Breadcrumb.Item key={node.id}>
                {i === path.length - 1 ? (
                  <a role="link" onClick={() => this.showMeta(node)}>
                    {node.name}
                  </a>
                ) : (
                  <Link to={`/assets/${node.id}`}>{node.name}</Link>
                )}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </BreadcrumbWrapper>
        <Search
          placeholder="Search for an asset"
          onChange={e => this.setState({ search: e.target.value })}
          style={{ width: '300px', marginBottom: '10px' }}
          value={search}
        />
        <List
          grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 3, xl: 4, xxl: 5 }}
          dataSource={slicer(dataSource)}
          loading={loading}
          locale={{ emptyText: 'This asset has no children.' }}
          pagination={{
            pageSize: 24,
            total: search.length > 0 ? dataSource.length : children.length,
            current: page,
            onChange: p => this.setState({ page: p }),
            hideOnSinglePage: true,
          }}
          renderItem={node => (
            <List.Item>
              <CardWrapper
                actions={[
                  <Icon type="login" onClick={() => this.onSelect(node)} />,
                  <Icon type="ellipsis" onClick={() => this.showMeta(node)} />,
                ]}
              >
                <MetaWrapper title={node.name} description={node.description} />
              </CardWrapper>
            </List.Item>
          )}
        />
        <RightSidebar
          open={selectedNode !== null}
          width={500}
          customStyle={{ marginRight: '-16px', height: 'calc(100vh - 50px)' }}
        >
          <div style={{ padding: '10px' }}>
            <AssetMeta
              node={selectedNode}
              requestMountedOn={this.requestMountedOn}
              // push={url => this.props.dispatch(push(url))}
              onClose={() =>
                this.setState({
                  selectedNode: null,
                })
              }
            />
          </div>
        </RightSidebar>
      </MainWrapper>
    );
  }
}

export default connect(state => ({
  project: state.project,
}))(AssetExplorerContainer);



// WEBPACK FOOTER //
// ./src/containers/AssetExplorerContainer.js